import loginHero from '@/shared/assets/login-hero.jpg';

import styles from './BrandPanel.module.scss';

type Props = {
  readonly className?: string;
};

// Desktop-only right-hand hero photo for the Allguth split-screen layout.
const BrandPanel = ({ className }: Props) => (
  <div className={className}>
    <img className={styles.image} alt="" src={loginHero} />
  </div>
);

export default BrandPanel;
